/** @jsxImportSource @emotion/react */

import type { ReactElement } from 'react';
import type { OmitFromKnownKeys } from '../../utils';
import ODSSwitch from '../ODSSwitch';

type Props = OmitFromKnownKeys<React.ComponentProps<typeof ODSSwitch>, 'type'>;

function ODSCheckbox(props: Props): ReactElement {
  return <ODSSwitch type="checkbox" {...props} />;
}

export default ODSCheckbox;
